import { Link } from "@mui/material";
import { GridCellParams } from "@mui/x-data-grid";
import { Link as RouterLink } from "react-router-dom";
import { SystemLog } from "../log/type";

export default function LogDetailButton(props: GridCellParams<SystemLog, any>) {
  return (
    <Link component={RouterLink} to={props.row.id.toString()}>
      Detay
    </Link>
  );
}
